import * as $ from "jquery";
import * as GC from '../grapecity';


/**
 * 
 */
export type DialogButtonsType = 'okOnly' | 'noOnly' | 'cancelOnly' | 'okOrNo' | 'okOrCancel' | 'all';

/**
 *
 */
export type DialogResultType = 'ok' | 'no' | 'cancel';

/**
 *
 */
type DialogIconType = 'info' | 'error' | 'warn';

/**
 *
 */
type DialogCallbacks = {
    onShow?: (Popup: Dialog, CancelEventArgs: GC.wijmo.CancelEventArgs) => boolean;
    onShown?: (Popup: Dialog, EventArgs: GC.wijmo.EventArgs) => void;
    onClose?: (Popup: Dialog, CancelEventArgs: GC.wijmo.CancelEventArgs) => boolean;
    onClosed?: (Popup: Dialog, EventArgs: GC.wijmo.EventArgs) => void;
};

export type DialogOption = {
    title: string;
    /**
     */
    bodyContent: any;
    /**
     */
    icon?: DialogIconType;
    /**
     */
    buttons?: DialogButtonsType;
    /**
     * 
     */
    callbacks?: DialogCallbacks;
}



/**
 * ダイアログに関する基底基盤
 */
class Dialog {

    /*
    * 
    * デフォルトでは、showTrigger プロパティはPopupTrigger.ClickOwner に設定されており、 オーナー要素をクリックすると、ポップアップが表示されます。
    * showTrigger プロパティをPopupTrigger.None に設定すると、 ポップアップはshow メソッドを呼び出すのみで表示されます。
    */
    protected static readonly defaultVenderOption = {
        isDraggable: false,
        showTrigger: GC.wjcInput.PopupTrigger.None,
        hideTrigger: GC.wjcInput.PopupTrigger.None,
    };

    /**
    * modalのインスタンス
    */
    protected modal: GC.wjcInput.Popup = null;

    /**
     * @deprecated
     */
    protected venderOptions: any = null;


    public readonly dialogOption: DialogOption;

    /**
    */
    protected content: any = null;

    /**
     */
    protected title: string = null;

    /**
     */
    protected bodyContent: any = null;

    /**
     */
    protected icon: DialogIconType = null;

    /**
     */
    protected buttons: DialogButtonsType;

    /**
     * show前
     */
    public onShow: (Popup: Dialog, CancelEventArgs: GC.wijmo.CancelEventArgs) => boolean = null;

    /**
     * show後
     */
    public onShown: (Popup: Dialog, EventArgs: GC.wijmo.EventArgs) => void = null;

    /**
     * close前
     */
    public onClose: (Popup: Dialog, CancelEventArgs: GC.wijmo.CancelEventArgs) => boolean = null;

    /**
     * close後
     */
    public onClosed: (Popup: Dialog, EventArgs: GC.wijmo.EventArgs) => void = null;

    /**
     * dialogResult
     */
    public get dialogResult(): DialogResultType {
        if (this.modal.dialogResult) {
            if (this.modal.dialogResult == 'wj-hide-ok') {
                return 'ok';
            } else if (this.modal.dialogResult == 'wj-hide-no') {
                return 'no';
            } else if (this.modal.dialogResult == 'wj-hide-cancel') {
                return 'cancel';
            }
        }
        //1623 確認メッセージでEscキーを押下するとOKと判断される
        //return 'ok';
        return 'cancel';
    }

    private container: JQuery<HTMLElement>;
    private header: JQuery<HTMLElement>;
    private body: JQuery<HTMLElement>;
    private footer: JQuery<HTMLElement>;
    private btnOk: JQuery<HTMLElement>;
    private btnNo: JQuery<HTMLElement>;
    private btnCancel: JQuery<HTMLElement>;


    /**
     * @param options
     */

    //constructor(content: Element | string, options?: any) {
    constructor(option: DialogOption) {

        this.dialogOption = option;
        this.title = option.title;
        this.bodyContent = option.bodyContent;
        this.icon = option.icon;

        this.buttons = option.buttons;

        if (option.callbacks) {
            if (option.callbacks.onShow) {
                this.onShow = option.callbacks.onShow;
            }
            if (option.callbacks.onShown) {
                this.onShown = option.callbacks.onShown;
            }
            if (option.callbacks.onClose) {
                this.onClose = option.callbacks.onClose;
            }
            if (option.callbacks.onClosed) {
                this.onClosed = option.callbacks.onClosed;
            }
        }

        //this.options = options;
        //this.content = element;
        this.makeContent(ret => {
            this.content = ret;
            //parentの指定は必要かも
            //$('body').append(this.content);

            this.initializePopUp();
            this.setEvent();
        });
    }

    //promiseモデル
    //protected abstract async setContent();

    /**
     * コンテントの収集(CBモデル)
     * @param 
     */
    protected makeContent(cb: (elem) => void) {

        //this.wijimoStyle();

        this.bootStrapStyle();


        cb(this.container);
    };


    /**
     * wijimoを主体としたStyle
     */
    wijimoStyle() {

        // * Header
        this.container = $('<div>');
        this.header = $('<div class="wj-dialog-header">');
        const title = $('<h5 class="modal-title"></h5>')

        let titleIcon;
        if (this.icon === 'info') {
            titleIcon = $('<i class="material-icons mr-2">notification_important</i>')
        }
        else if (this.icon === 'error') {
            titleIcon = $('<i class="material-icons mr-2">error</i>')
        }
        else if (this.icon === 'warn') {
            titleIcon = $('<i class="material-icons mr-2">warnig</i>')
        }
        title.append(titleIcon);

        //エスケープ必要？（サニタイジング）
        const titleText = $('<span>')
        titleText.append(this.title);
        title.append(titleText);
        this.header.append(title);
        this.container.append(this.header);


        // * Body
        this.body = $('<div class="wj-dialog-body" tabindex="-1">');//wjm
        //エスケープ必要？（サニタイジング）
        this.body.append(this.bodyContent);
        this.container.append(this.body);

        // * Footer
        //Popup 内に'wj-hide'文字列で始まるクラスを持つクリック可能な 要素がある場合は、その要素がクリックされるとPopup は非表示になります。
        //さらに、そのクラス名にPopup.dialogResult プロパティが設定され、 呼び出し元が適切なアクションを実行できます。
        //たとえば、ユーザーが［OK］または［キャンセル］ボタンを クリックすると非表示になり、
        //Popup.dialogResult プロパティが 'wj-hide-cancel'または'wj-hide-ok'のいずれかに設定されます。

        this.footer = $('<div class="wj-dialog-footer">');
        if (this.buttons === "okOnly" || this.buttons === "okOrNo" || this.buttons === "all") {
            this.btnOk = $('<button class="btn btn-primary wj-hide-ok">OK</button>');
            this.footer.append(this.btnOk);
        }

        if (this.buttons === "noOnly" || this.buttons === "okOrNo" || this.buttons === "all") {
            this.btnNo = $('<button class="btn btn-secondary wj-hide-no">NO</button>');
            this.footer.append(this.btnNo);
        }

        if (this.buttons === "cancelOnly" || this.buttons === "okOrCancel" || this.buttons === "all") {
            this.btnCancel = $('<button class="btn btn-dark wj-hide-cancel">Cancel</button>');
            this.footer.append(this.btnCancel);
        }
        this.container.append(this.footer);
    }
    /**
     * bootStrapを主体としたStyle
     */
    bootStrapStyle() {

        // * Header
        //this.container = $('<div class="modal-content">');//bs
        this.container = $('<div>');//bs

        this.header = $('<div class="modal-header">');//bs
        const title = $('<h5 class="modal-title"></h5>')

        let titleIcon;
        if (this.icon === 'info') {
            titleIcon = $('<i class="material-icons mr-2">notification_important</i>')
        }
        else if (this.icon === 'error') {
            titleIcon = $('<i class="material-icons mr-2">error</i>')
        }
        else if (this.icon === 'warn') {
            titleIcon = $('<i class="material-icons mr-2">warnig</i>')
        }

        title.append(titleIcon);

        //エスケープ必要？（サニタイジング）
        const titleText = $('<span>')
        titleText.append(this.title);
        title.append(titleText);

        this.header.append(title);
        this.container.append(this.header);

        // * Body
        this.body = $('<div class="modal-body">');//bs
        //エスケープ必要？（サニタイジング）
        this.body.append(this.bodyContent);
        this.container.append(this.body);

        // * Footer
        //Popup 内に'wj-hide'文字列で始まるクラスを持つクリック可能な 要素がある場合は、その要素がクリックされるとPopup は非表示になります。
        //さらに、そのクラス名にPopup.dialogResult プロパティが設定され、 呼び出し元が適切なアクションを実行できます。
        //たとえば、ユーザーが［OK］または［キャンセル］ボタンを クリックすると非表示になり、
        //Popup.dialogResult プロパティが 'wj-hide-cancel'または'wj-hide-ok'のいずれかに設定されます。

        //this.footer = $('<div class="wj-dialog-footer">');
        this.footer = $('<div class="modal-footer">');

        if (this.buttons === "okOnly" || this.buttons === "okOrNo" || this.buttons === "all") {
            this.btnOk = $('<button class="btn btn-primary wj-hide-ok">OK</button>');
            this.footer.append(this.btnOk);
        }

        if (this.buttons === "noOnly" || this.buttons === "okOrNo" || this.buttons === "all") {
            this.btnNo = $('<button class="btn btn-secondary wj-hide-no">NO</button>');
            this.footer.append(this.btnNo);
        }

        if (this.buttons === "cancelOnly" || this.buttons === "okOrCancel" || this.buttons === "all") {
            this.btnCancel = $('<button class="btn btn-dark wj-hide-cancel">Cancel</button>');
            this.footer.append(this.btnCancel);
        }
        this.container.append(this.footer);
    }


    /**
     * 
     */
    protected initializePopUp() {

        //イベントFork
        const events = {
            showing: (p: GC.wjcInput.Popup, e: GC.wijmo.CancelEventArgs) => {
                let ret = true;
                if (this.onShow) {
                    ret = this.onShow.call(this, this, e);
                    ret = (ret) ? e.cancel : ret;
                }
                return ret;
            },

            shown: (p: GC.wjcInput.Popup, e: GC.wijmo.EventArgs) => {
                this.onShown?.call(this, this, e);
            },

            hiding: (p: GC.wjcInput.Popup, e: GC.wijmo.CancelEventArgs) => {
                let ret = true;
                if (this.onClose) {
                    ret = this.onClose.call(this, this, e);
                    ret = (ret) ? e.cancel : ret;
                }
                return ret;
            },

            hidden: (p: GC.wjcInput.Popup, e: GC.wijmo.EventArgs) => {
                this.onClosed?.call(this, this, e);
            }
        }
        const _options = jQuery.extend(true, {}, Dialog.defaultVenderOption, events);

        // create forms
        this.modal = new GC.wjcInput.Popup(this.content, _options);

        //各種イベントはReadOnlyな為、下記は許可されない。コンストラクタでOptionとして渡す必要がある
        //this.modal.hiding((p, e) => {
        //    this.onShow?.call(this, e);
        //});
    }

    /**
     * 
     * @param closeCb
     */
    protected setEvent() {
        //$.noop();
    }

    /**
     * 
     * @param _param
     * @param _closeCb
     */
    show() {
        //
        this.modal.show(true);
    }

    /**
     * @param dialogResult
     */
    close(dialogResult?: DialogResultType) {

        this.modal.hide(dialogResult);
    }
}



/**
 * ダイアログの表示
 * @param title
 * @param content
 * @param buttons
 * @param callback
 */
function ShowDialogInner(title: string, content: any, buttons: DialogButtonsType = 'okOrNo', icon: DialogIconType = 'info', callbacks?: DialogCallbacks): Dialog {
    const option: DialogOption = {
        title: title,
        bodyContent: content,
        buttons: buttons,
        icon: icon,
        callbacks: callbacks
    };
    const dlg = new Dialog(option);

    dlg.show();
    return dlg;
}

/** Publish Method */
/**
 * ダイアログの表示
 * @param title
 * @param content
 * @param buttons
 * @param callback
 */
export function ShowDialog(title: string, content: any, buttons: DialogButtonsType = 'okOrNo', icon: DialogIconType = 'info', callback?: (result: DialogResultType) => void): Dialog {

    const dlg = ShowDialogInner(title, content, buttons, icon);
    dlg.onClosed = (d, e) => {
        callback?.call(this, d.dialogResult);
    }
    return dlg;
}

/**
 * メッセージダイアログの表示
 * @param title
 * @param content
 * @param callback
 */
export function MessgeDialog(title: string, content: any, callback?: (result: DialogResultType) => void): Dialog {

    //let potion: dialogOption = {
    //    title: title, content: content, callbacks: { onClosed : callback }
    //}
    //const option: dialogOption = { title: title, content: content, buttons: "okOnly" };
    //const dlg = new dialog(option);
    //dlg.onClosed = (d, e) => {
    //    callback?.call(this, d.dialogResult);
    //}
    //return dlg;

    //const dlg = ShowDialog(title, content, "okOnly");
    //dlg.onClosed = (d, e) => {
    //    callback?.call(this, d.dialogResult);
    //}

    const dlg = ShowDialog(title, content, 'okOnly', 'info', callback);
    return dlg;
}

/**
 * 確認ダイアログの表示
 * @param title
 * @param content
 * @param callback
 */
export function ConfirmDialog(title: string, content: any, callback?: (result: DialogResultType) => void): Dialog {

    //const option: dialogOption = { title: title, content: content, buttons: "okOrNo" }
    //const dlg = new dialog(option);
    //dlg.onClosed = (d, e) => {
    //    callback?.call(this, d.dialogResult);
    //}
    //return dlg;

    //const dlg = ShowDialog(title, content, "okOrNo");
    //dlg.onClosed = (d, e) => {
    //    callback?.call(this, d.dialogResult);
    //}
    const dlg = ShowDialog(title, content, 'okOrNo', 'info', callback);
    return dlg;
}
